import { render, staticRenderFns } from "./tzproduct2.vue?vue&type=template&id=1c084be2&scoped=true"
import script from "./tzproduct2.vue?vue&type=script&lang=js"
export * from "./tzproduct2.vue?vue&type=script&lang=js"
import style0 from "./tzproduct2.vue?vue&type=style&index=0&id=1c084be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c084be2",
  null
  
)

export default component.exports